<template>
  <!-- 文本位置
       @author: 王汝鹏
       @date: 2019-9-20
   -->
  <div class="setting-item">
    <el-form-item label="文本位置"> 
      <el-select class="setting-line-text-position" v-model="textPosition">
        <el-option value="flex-start" label="左边"></el-option>
        <el-option value="center" label="中间"></el-option>
        <el-option value="flex-end" label="右边"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 文本位置
     *  @description 将 textPosition 字段映射到当前 textPosition 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-20
     */
    ...mapComputed({
      textPosition: { 
        parent: i => i.baseOption,
        attr: "textPosition" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingLineTextPosition.vue